import type * as store from '@attain-apps/fe/web/main/lib/store'

import type * as ecModels from '../../../models'

import type * as models from './models'

export type Config<TTypeParams extends ecModels.TypeParams.Constraint> = {
  [K in keyof models.Storage<TTypeParams>]: store.storage.PropertyConfig.WithoutMarker<
    models.Storage<TTypeParams>[K]
  >
} & {
  /**
   * Controls how the current list is updated after a successful entity
   * creation.
   *
   * - `'optimistic'` (default): the new entity is inserted directly into the
   *   list without a server round-trip. Use when no filters are applied or when
   *   the new entity is guaranteed to match the current filter criteria.
   *
   * - `'pessimistic'`: the list is reloaded from the server after creation. Use
   *   when filters or search are active, as the server is the source of truth
   *   for which entities belong in the filtered view.
   *
   * @default 'optimistic'
   */
  creationStrategy: Config.CreationStrategy
}
export namespace Config {
  export type CreationStrategy = 'optimistic' | 'pessimistic'

  export function from<TTypeParams extends ecModels.TypeParams.Constraint>(
    config: Config.Options<TTypeParams> | undefined,
  ): Config<TTypeParams> {
    return {
      ...config,
      creationStrategy: config?.creationStrategy ?? 'optimistic',
    } as Config<TTypeParams>
  }

  export type Options<TTypeParams extends ecModels.TypeParams.Constraint> =
    Partial<Config<TTypeParams>>
}
